<template>
  <div class="topo w-100 ui-image--cover" :style="'background-image: url('+require('../assets/img/topo_blog.jpg')+')'">
    <div class="container h-100">
      <div class="row h-100 justify-content-between align-items-center">
        <div class="col-md-6 col-12">
          <h1 class="ui-title ui-title--intern ui-title--white ui-title--uppercase">
            <b>Blog Comcasa</b>
          </h1>
        </div>
        <div class="col-xl-4 col-lg-5 col-md-6 col-12">
          <div class="topo__cadastro__title">
            <h2>
              Cadastre-se para receber <b>conteúdo exclusivo</b>
            </h2>
            <a data-toggle="modal" data-target="#ModalVip">
              <button class="ui-button ui-button--transparent-white">
                Quero ser VIP
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- modal area inicio -->
    <div class="modal fade" id="ModalVip" tabindex="-1" role="dialog" aria-labelledby="ModalVipLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>
              Quero ser <b>VIP</b>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm" class="w-100 text-right">
              <input type="text" v-model="form.name" class="ui-input ui-input--green" placeholder="Nome" required>
              <input type="email" v-model="form.email" class="ui-input ui-input--green" placeholder="E-mail" required>
              <button class="ui-button" type="submit" :disabled="disabled">
                {{submitButton}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- modal area fim -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
export default {
  data () {
    return {
      update: false,
      disabled: false,
      submitButton: 'Enviar',
      form: {
        name: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapGetters(['contactSend'])
  },
  methods: {
    submitForm () {
      this.disabled = true
      this.submitButton = 'Enviando'
      let content = {
        'destiny': 'faleconosco.comcasa@gmail.com',
        'originName': 'Website Comcasa',
        'title': 'Interesse em ser VIP',
        'message': `Uma pessoa tem interesse em receber conteúdo exclusivo da Comcasa:<br><br>Nome: ${this.form.name}<br>E-mail: ${this.form.email}`
      }
      this.$store.dispatch('sendContactForm', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.form})
          swal(
            'Enviado :)',
            'E-mail enviado com sucesso.',
            'success'
          )
          this.form = {
            name: '',
            email: ''
          }
          this.disabled = false
          this.submitButton = 'Enviar'
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.topo {
  height: 70vh;
  padding-top: 100px;
  @media (max-width: 1600px) {
    height: 60vh;
  }
  @media (max-width: 1400px) {
    height: 65vh;
  }
  @media (max-width: 500px){
    height: 60vh;
    .ui-title--intern {
      text-align: center!important;
    }
  }
  &__cadastro__title {
    h2 {
      color: white;
      font-size: 24px;
      line-height: 24px;
      margin-bottom: 40px;
      b {
        font-weight: 900;
      }
    }
    button {
      min-width: inherit;
      width: 100%;
    }
  }
  .modal-header {
    h5 {
      font-size: 24px;
    }
  }
  @media (max-width: 991px){
  }
  @media (max-width: 767px){
    &__cadastro__title {
      h2 {
        font-size: 22px;
        margin-bottom: 30px;
        text-align: center
      }
    }
    .modal-header {
      h5 {
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BannerInternoBlog.vue